import actionTypes from 'constants/actionTypes';

import { TradingOfferType } from 'types/TradingOffer';
import { AddTradingOfferPageProvider } from '../pages/AddTradingOffer/context/AddTradingOfferPageContext';
import AddTradingOfferPage from '../pages/AddTradingOffer';

const EditSellTradingOfferPageContainer = () => (
  <AddTradingOfferPageProvider
    tradingOfferType={TradingOfferType.SELL}
    actionType={actionTypes.EDIT}
  >
    <AddTradingOfferPage />
  </AddTradingOfferPageProvider>
);

export default EditSellTradingOfferPageContainer;
